const defaultPreferencesType = {
    STUDIO : 1,

    OPERATOR : 2

};

angular.module('gw-um-j2js')
    .constant('defaultPreferencesType', defaultPreferencesType);